import { CircleCheckFilled } from 'baseui/icon'
import useFidelityMaximizerSidebar from './useFidelityMaximizerSidebar'
import { MailIcon, ChartIcon, PersonIcon, PhoneIcon } from './icons'
import {
  StyledContainer,
  StyledTopContainer,
  StyledHeader,
  StyledTitle,
  StyledIndicator,
  StyledCurrentValue,
  StyledSubtitle,
  StyledProgressBarContainer,
  StyledProgressTrack,
  StyledProgressMask,
  StyledItemsContainer,
  StyledItemRow,
  StyledItemLeft,
  StyledItemLabel,
  StyledDoneIcon,
  StyledPendingIcon,
} from './styled-components'

const ITEM_ICONS = {
  nlbp_classic: MailIcon,
  nlbp_personalized: ChartIcon,
  myselectra: PersonIcon,
  app_downloaded: PhoneIcon,
}

const FidelityMaximizerSidebar = () => {
  const { t, hidden, items, currentValue, maxValue, isMastered, percentDone } = useFidelityMaximizerSidebar()

  if (hidden) {
    return null
  }

  const title = isMastered
    ? `🏆 ${t('subscriptionForm:fidelity_maximizer_module.maximized_label')}`
    : t('subscriptionForm:fidelity_maximizer_module.sidebar_title')
  const subtitle = t(
    isMastered
      ? 'subscriptionForm:fidelity_maximizer_module.sidebar_subtitle_mastered'
      : 'subscriptionForm:fidelity_maximizer_module.sidebar_subtitle',
  )

  return (
    <StyledContainer $mastered={isMastered}>
      <StyledTopContainer>
        <StyledHeader>
          <StyledTitle>{title}</StyledTitle>
          <StyledIndicator>
            <StyledCurrentValue $reachedMax={isMastered}>{currentValue}</StyledCurrentValue>/{maxValue}
          </StyledIndicator>
        </StyledHeader>
        <StyledSubtitle>{subtitle}</StyledSubtitle>
        <StyledProgressBarContainer>
          <StyledProgressTrack $mastered={isMastered}>
            <StyledProgressMask $percentDone={percentDone} />
          </StyledProgressTrack>
        </StyledProgressBarContainer>
      </StyledTopContainer>
      <StyledItemsContainer>
        {items.map(item => {
          const PendingIcon = ITEM_ICONS[item.key]
          return (
            <StyledItemRow key={item.key} $done={item.done}>
              <StyledItemLeft>
                {item.done ? (
                  <StyledDoneIcon>
                    <CircleCheckFilled size={20} />
                  </StyledDoneIcon>
                ) : (
                  <StyledPendingIcon>
                    <PendingIcon size={20} />
                  </StyledPendingIcon>
                )}
                <StyledItemLabel $done={item.done}>
                  {t(`subscriptionForm:fidelity_maximizer_module.checklist.${item.key}`)}
                </StyledItemLabel>
              </StyledItemLeft>
            </StyledItemRow>
          )
        })}
      </StyledItemsContainer>
    </StyledContainer>
  )
}

export default FidelityMaximizerSidebar
